<template>
	<div class="uk-modal-dialog uk-modal-body">
		<h2 class="uk-modal-title">Placement Ratings</h2>
		<form ref="form" class="">
			<div v-for="(cat, index) in ratingCategories" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
				<div class="uk-width-1-2">
					{{ cat.name }}
				</div>
				<div class="uk-width-1-4">
					<label class="uk-form-label">
						<input class="uk-input" type="number" min="0" max="5" v-model="cat.rating" />
					</label>
				</div>
				<div class="uk-width-1-4">
					<label v-if="cat.is_optional" class="uk-form-label">
						Optional
					</label>
				</div>
			</div>
			<div>
				<label for="manager_notes" class="uk-form-label">
					Field Manager Notes
				</label>
				<div class="uk-form-controls">
					<textarea id="manager_notes" name="fm_notes" rows="4" class="uk-textarea rounded" v-model="mgrNote"></textarea>
				</div>
			</div>
			<div>
				<label for="other_notes" class="uk-form-label">
					Other Notes
				</label>
				<div class="uk-form-controls">
					<textarea id="other_notes" name="other_notes" rows="4" class="uk-textarea rounded" v-model="otherNote"></textarea>
				</div>
			</div>
			<button class="uk-button uk-button-primary uk-margin-small-top" type="button" @click="submitRatings">Save Ratings</button>
		</form>
	</div>
</template>

<script>

export default {
	name: "RatingForm",

	props: {},
	components: {},
	data() {
		return {
			id:null,
			ratingCategories:[{
				id:null,
				name:"",
				rating: null,
				is_optional:false
			}],
			mgrNote:"",
			otherNote:""
		}
	},
	mounted() {

	},
	methods: {
		loadForm(id){
			this.id = id;
			this.ratingCategories = [{
				id:null,
				name:"",
				rating: null,
				is_optional:false
			}];
			axios.get("/api/rating/categories/" + id).then((pack) => this.updateFormData(pack));
		},
		updateFormData(pack){
			if(pack.data && pack.data.success){
				this.ratingCategories = pack.data.data.ratingCategories;
				if(pack.data.data.managerNote){
					this.mgrNote = pack.data.data.managerNote.content;
				}
				else {
					this.mgrNote = "";
				}
				if(pack.data.data.otherNote){
					this.otherNote = pack.data.data.otherNote.content;
				}
				else {
					this.otherNote = "";
				}
			}
		},
		submitRatings(){
			for(let i = 0; i < this.ratingCategories.length;++i){
				let category = this.ratingCategories[i];
				if(category.rating !== null && category.id !== null){
					axios.post("/api/rating/rate", {
						rating: category.rating,
						placementId: this.id,
						categoryId: category.id,
					})
						.then(() => {}) //we really shouldn't need to do anything
						.catch(() => {});
				}
			}
			
			if(this.mgrNote !== null && this.mgrNote.trim() !== ""){
				axios.post("/api/rating/note", {
					placementId: this.id,
					type:"manager",
					note:this.mgrNote
				})
					.then(() => {}) //we really shouldn't need to do anything
					.catch(() => {});
			}
			
			if(this.otherNote !== null && this.otherNote.trim() !== ""){
				axios.post("/api/rating/note", {
					placementId: this.id,
					type:"other",
					note:this.otherNote
				})
					.then(() => {}) //we really shouldn't need to do anything
					.catch(() => {});
			}

			//emit and "I'm done" message
			this.$emit("complete");
		}
	},
	watch: {}
}
</script>